import React, { useState ,useEffect } from 'react';
import './DynamicElementList.scss';
import PropTypes from 'prop-types';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';

const DynamicElementList = ({
  elementName,
  Component,
  addButtonText,
  removeButtonText,
  elements,
  initialData,
  setElements,
  onElementsChange,
  isRequired,
  componentProps,
  limit,
  isSubmit,
  validationBeforeAdd,
  validationText,
}) => {

  const [error, setError] = useState(null);
  elements = elements?.length == 0 ? [initialData] : elements;
 
  validationText = validationText ?? 'יש להשלים את כל הפרטים בכדי להמשיך';
  const lastElement = elements[elements.length - 1];

  useEffect(() => {
    if(error){
      validateLastElement();
    }
  }, [lastElement]);

  const handleAdd = async () => {
    const validationResult = await validateLastElement();
    if(validationResult){
      const newElements = [...elements,initialData];
      setElements(newElements);
    }
  };

   const validateLastElement = async () => {
    if(validationBeforeAdd){
      const validationResult = await validationBeforeAdd();
      if(!validationResult){
        setError(validationText);
        return false;
      }else{
        setError(null);
        return true;
      }
   }
   return true;
  }



  const handleRemove = (idx) => {
    const newElements = elements.filter((_, i) => i !== idx);
    setElements(newElements);
  };

  const handleElementChange = (elementIdx, updatedData) => {
    const newElements = [...elements];
    newElements[elementIdx] = { ...newElements[elementIdx], ...updatedData };
    setElements(newElements);
  };



  return (
    <div className={`dynamic-element-list ${Component.displayName}`}>
      {elements.map((element, elementIdx) => (
        <div className="element-block" key={elementIdx}>         
          <div className="element-container">
            <div className="generic-component-container">
              <Component
                {...componentProps}
                data={element}
                index={elementIdx}
              />
            </div>
            {isRequired && elements.length > 1 && (
            <button
              className="remove-btn"
              onClick={() =>  handleRemove(elementIdx) }
              type="button"
            >
              <span >✕ {removeButtonText} </span>
            </button>
            )}
          </div>
        </div>
      ))}
      { (isNullOrEmpty(limit)  || elements.length < limit) && 
          <button className="add-btn" onClick={handleAdd} type="button">
            <span >＋ {addButtonText} </span>
          </button>
       }  
      {error  && <div className="error-message">{error}</div>}
    </div>
  );
};

DynamicElementList.propTypes = {
  Component: PropTypes.elementType.isRequired,
  addButtonText: PropTypes.string.isRequired,
  removeButtonText: PropTypes.string.isRequired,
  initialData: PropTypes.object.isRequired,
  elements: PropTypes.array.isRequired,
  onElementsChange: PropTypes.func,
  checkDuplicate: PropTypes.func,
  errorDuplicateText: PropTypes.string,
};

export default DynamicElementList;